import {API} from "aws-amplify";
import {GRAPHQL_AUTH_MODE, GraphQLQuery} from "@aws-amplify/api";
import {RefineMatchQuery, RefineMatchQueryVariables} from "../../API";
import * as queries from "../../graphql/queries";

export const refineSpecialTools = async (
    specialToolIds: String,
    topK: number
): Promise<any> => {
    try {
        const result = await API.graphql<GraphQLQuery<RefineMatchQuery>>({
            query: queries.refineMatch,
            variables: {
                specialToolIds: specialToolIds,
                topK: topK,
            } as RefineMatchQueryVariables,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
        });

        if (result.data) {
            const data = result.data.refineMatch;
            if (data) {
                const parsedData = JSON.parse(data);
                return JSON.parse(parsedData["manuals"]);
            }
        }
    } catch (error) {
        console.error(error);
    }
};
